<div class="background">
  <div class="info-background"
    [lazyLoad]="backgroundImage"
    [style.background-image]="!backgroundImage ? backgroundGradient : null"
    (onStateChange)="lazyLoadOnStatechange($event)">
  </div>
  <div class="main-background"></div>
</div>

<div class="content-wrapper">
  <div class="content">
    <div #overlayContent
      class="overlay-content"
      [lazyLoad]="backgroundImage"
      [style.background-image]="backgroundGradient">
      <ng-content select="[infoOverlay]"></ng-content>
    </div>
    <div class="main-content">
      <ng-content select="[mainContent]"></ng-content>
    </div>
  </div>
</div>
